import { Select } from '@bepro-travel/fe.ui';
export interface Gross {
  fBase: number;
  currency: string;
  baseCurrencyCode: number;
  eur: number;
  usd: number;
  gbp: number;
  loc: number;
  netValue: number;
  llv: string;
  mv: string;
  value: number;
}
export interface Tax {
  fBase: number;
  currency: string;
  baseCurrencyCode: number;
  eur: number;
  usd: number;
  gbp: number;
  loc: number;
  netValue: number;
  llv: string;
  mv: string;
  value: number;
}
export interface CmsPageResponse {
  clubDiscountText: string;
  clubLogoUrl: string;
  page: Page;
  siteConfig: SiteConfig;
  pageHeader: PageHeader;
  pageFooter: PageFooter;
  pageItems: PageItem[];
  hasErrors: boolean;
  errorMessage: any;
  loading: {
    loadingPage: LoadingPage;
    pageContent: PageContent;
  };
  needRefresh: boolean;
  refreshKey: string;
}
export interface LoadingPage {
  active: boolean;
  hiddenPage: number;
  hiddenFromALL: number;
  title: Title;
  category: string;
  systemBasic: string;
  systemProducts: string;
  systemPageTemplate: string;
  listOfAtrributes: ListOfAtrribute[];
  strListOfAtrributes: string;
  listOfParamsAttr: any[];
  strListOfParamsAttr: string;
  systemProductsDetails: string;
  params: Params;
  listOfGalleryId: ListOfGalleryId[];
  strListOfGalleryId: string;
  externalDesc: string;
  languages: Language[];
  strLanguages: string;
  country: Country;
  city: City;
  geoCode: GeoCode;
  cmsScripts: CmsScripts;
  id: number;
  parentId: number;
  uKey: string;
  parentKey: string;
  extKey: string;
  webKey: string;
  companyId: number;
  departmentId: number;
  branchId: number;
  userC: number;
  userU: number;
  userX: number;
  dateC: string;
  dateU: string;
  dateX: string;
  orderDisplay: number;
  delRow: number;
}
export interface Sales {
  tabs: Tab[];
}
export interface ContactUsResponse {
  emailSent: boolean;
  errorMessage: string;
  hasErrors: boolean;
}
export interface GuidesListResponse {
  guidePages: Page[];
  errorMessage?: string;
  hasErrors?: boolean;
}
export interface PelegGroup {
  dates: Select[];
  deal: PelegSales;
  selected: string;
  pricePerPerson: number;
  totalPrice: number;
  roomDescription: string;
  boardDescription: string;
  nights: number;
  routingValues: any;
  status: string;
  allPhotos?: any[];
  hotelName?: string;
  checkIn?: string;
  checkOut?: string;
}
export interface Tab {
  alpDeals: AlpDeal[];
  flightsDeals: any[];
  beTopPackagesDeals: any[];
  beProHotels: any[];
  pelegSales: PelegSales[];
  pelegGroups?: PelegGroup[];
  tab: {
    title: {
      desc: string;
    };
  };
  dealTypes: any;
}
export interface PelegSales {
  hotelName: string;
  mainImageLink: string;
  mainImageAlt: string;
  checkIn: string;
  checkOut: string;
  roomDescription: string;
  boardDescription: string;
  nights: number;
  images: Image[];
  currencySymbol: string;
  totalPrice: number;
  pricePerPerson: number;
  routingValues: RoutingValues;
  status: string;
}
export interface Image {
  link: string;
  thumb: string;
  alt: string;
}
export interface RoutingValues {
  searchToken: any;
  hotelName: string;
  cityCode: string;
  checkIn: string;
  nights: number;
  dealId: string;
  packageId: string;
  room: string;
}
export interface AlpDeal {
  dealTitle?: string;
  dealId: string;
  rowId: string;
  ldsDealId: any;
  providerCode: any;
  provider: string;
  dealType: string;
  dealFeature: string;
  source: string;
  listOfDealFeature?: string[];
  departureDate: string;
  rowName: string;
  hotelRating: string;
  carGroup: string;
  dealLength: string;
  serviceLength: number;
  fareBasis: string;
  paxComplect: string;
  bpRoomType: string;
  roomType: string;
  displayPrice: number;
  dispalyCurrency: string;
  price: number;
  discount: number;
  discountId: number;
  discountCode: any;
  discountProviderCode: any;
  discountTypeId: any;
  discountMaxSum: any;
  salePrice: number;
  tax: number;
  commission: number;
  commissionType: string;
  netPrice: boolean;
  infantPrice: number;
  saleInfantPrice: number;
  childPrice: number;
  saleChildPrice: number;
  singlePrice: number;
  saleSinglePrice: number;
  thirdPrice: number;
  saleThirdPrice: number;
  additionalPrice: number;
  saleAdditionalPrice: number;
  adultPrice: number;
  saleAdultPrice: number;
  currency: string;
  chain: string;
  flag: string;
  hotelId: string;
  normalPrice: number;
  dealDestination: string;
  flightDestination: string;
  dealDestinationReturn: string;
  destination: any;
  flightId: number;
  inF_Num: number;
  adT_Num: number;
  cnN_Num: number;
  paX_Num: number;
  multiPrice: MultiPrice;
  uniqueKey: string;
  parentUniqueKey: any;
  fastOK: boolean;
  dealImage: string;
  url: any;
  bToken: string;
  listeOfAlpDateDeal: any[];
  hide: boolean;
  findIncludeExclude: boolean;
  remark: any;
}
export interface MultiPrice {
  gross: Gross;
  tax: Tax;
}
export interface Page {
  active: boolean;
  hiddenPage: number;
  hiddenFromALL: number;
  title: Title;
  category: string;
  systemBasic: string;
  systemProducts: string;
  systemPageTemplate: string;
  listOfAtrributes: ListOfAtrribute[];
  strListOfAtrributes: string;
  listOfParamsAttr: ListOfAtrribute[];
  strListOfParamsAttr: string;
  systemProductsDetails: string;
  params: Params;
  listOfGalleryId: any[];
  strListOfGalleryId: string;
  externalDesc: string;
  languages: Language[];
  strLanguages: string;
  country: Country;
  city: City;
  geoCode: GeoCode;
  cmsScripts: CmsScripts;
  id: number;
  parentId: number;
  uKey: string;
  parentKey: string;
  extKey: string;
  webKey: string;
  companyId: number;
  departmentId: number;
  branchId: number;
  userC: number;
  userU: number;
  userX: number;
  dateC: string;
  dateU: string;
  dateX: string;
  orderDisplay: number;
  delRow: number;
}
export interface Title {
  desc: string;
  stringCompress: any;
  sub: string;
  menu: string;
  url: string;
  tab: string;
  openBlankURL: boolean;
  body: string;
}
export interface Attribute {
  id: number;
  code: string;
  codeR2: any;
  desc: string;
}
export interface Params {
  param_1: string;
  param_2: string;
  param_3: string;
  param_4: string;
  param_5: string;
}
export interface Language {
  language: string;
  title: Title;
  title_2: Title;
  title_3: Title;
  title_4: Title;
  title_5: Title;
  seo: Seo;
  tabs: Tab[];
  tags: any[];
  listOfGalleryId: any[];
  script1: any;
  script2: any;
  script3: any;
  uKey: string;
  parentKey: any;
  active: boolean;
  parentId: number;
  id: number;
  name: Name;
}
export interface Seo {
  keywords: any;
  description: string;
  title: string;
  canonical: string;
  pram_1: any;
  pram_2: any;
}
export interface Tab {
  orderDisplayTab: number;
  tabCategory: string;
  title: Title6;
  maxElements: number;
  elementsInRow: number;
  openBlankURL: boolean;
  listOfAttributes: ListOfAttribute[];
  listOfGalleryId: ListOfGalleryId[];
  tags: any[];
  uKey: string;
  parentKey: any;
  active: boolean;
  parentId: number;
  id: number;
  name: Name;
}
export interface Title6 {
  desc?: string;
  stringCompress: any;
  sub: any;
  menu?: string;
  url: any;
  tab?: string;
  openBlankURL: boolean;
  body?: string;
}
export interface ListOfAttribute {
  id: number;
  code: string;
  sCode: string;
  name: string;
}
export interface ListOfGalleryId {
  orderId: number;
  main: boolean;
  footer: boolean;
  param1: boolean;
  param2: boolean;
  mobileHidden: boolean;
  listOfLangs: ListOfLang[];
  id: number;
  code: string;
  alt: string;
  desc: string;
}
export interface ListOfLang {
  uKey: any;
  language: Language;
  id: number;
  desc: any;
  listOfDesc: ListOfDesc[];
  url: any;
  openBlank: boolean;
  param_desc: any;
  param: boolean;
}
export interface ListOfDesc {
  id: number;
  code: string;
  sCode: string;
  name: string;
}
export interface Name {
  id: number;
  code: string;
  sCode: string;
  name: string;
}
export interface Country {
  id: number;
  code: string;
  sCode: string;
  name: string;
}
export interface City {
  id: number;
  code: string;
  sCode: string;
  name: string;
}
export interface GeoCode {
  latitude: string;
  longitude: string;
  pip: string;
}
export interface CmsScripts {
  desc: any;
  stringCompress: string;
  sub: any;
  menu: any;
  url: any;
  tab: any;
  openBlankURL: boolean;
  body: any;
}
export interface SiteConfig {
  languages: Language3[];
  siteLanguages: any[];
  name: Name4;
  siteBody: any;
  geoCode: any;
  themeColor: any;
  fontColor: any;
  phone1: string;
  phone2: any;
  phone3: any;
  fax1: any;
  fax2: any;
  fax3: any;
  email1: string;
  email2: any;
  email3: any;
  facebook: string;
  google: any;
  youtube: string;
  twitter: string;
  instagram: string;
  googleAnalytics: any;
  anotherAnalytics: any;
  script1: any;
  script2: any;
  script3: any;
  siteKey1: any;
  siteKey2: any;
  siteKey3: any;
  logoImage1: any;
  logoImage2: any;
  logoImage3: any;
  address1: any;
  address2: any;
  address3: any;
  googleTagManager: any;
  maxMainItemsCount: number;
  myPaymentSettings: MyPaymentSettings;
  manageCmsProducts: ManageCmsProducts;
  redirectBody: string;
  listOfCmsRedirect: any[];
  listOfCmsCheckOut: ListOfCmsCheckOut[];
  siteInsurance: SiteInsurance;
  breadcrumbs: boolean;
  id: number;
  parentId: number;
  uKey: string;
  parentKey: any;
  extKey: any;
  webKey: string;
  companyId: number;
  departmentId: number;
  branchId: number;
  userC: number;
  userU: number;
  userX: number;
  dateC: string;
  dateU: string;
  dateX: string;
  orderDisplay: number;
  delRow: number;
}
export interface Language3 {
  siteName: string;
  poweredBy: any[];
  allRightsReserved: any;
  allRightsReserved2: any;
  country: any;
  city: any;
  address: any;
  workingHours: any;
  language: string;
  title: Title7;
  title_2: Title23;
  title_3: Title32;
  title_4: Title42;
  title_5: Title52;
  seo: Seo2;
  tabs: any[];
  tags: any[];
  listOfGalleryId: any[];
  script1: any;
  script2: any;
  script3: any;
  uKey: string;
  parentKey: any;
  active: boolean;
  parentId: number;
  id: number;
  name: Name3;
}
export interface Title7 {
  desc: any;
  stringCompress: any;
  sub: any;
  menu: any;
  url: any;
  tab: any;
  openBlankURL: boolean;
  body: any;
}
export interface Title23 {
  desc: any;
  stringCompress: any;
  sub: any;
  menu: any;
  url: any;
  tab: any;
  openBlankURL: boolean;
  body: any;
}
export interface Title32 {
  desc: any;
  stringCompress: any;
  sub: any;
  menu: any;
  url: any;
  tab: any;
  openBlankURL: boolean;
  body: any;
}
export interface Title42 {
  desc: any;
  stringCompress: any;
  sub: any;
  menu: any;
  url: any;
  tab: any;
  openBlankURL: boolean;
  body: any;
}
export interface Title52 {
  desc: any;
  stringCompress: any;
  sub: any;
  menu: any;
  url: any;
  tab: any;
  openBlankURL: boolean;
  body: any;
}
export interface Seo2 {
  keywords: any;
  description: string;
  title: string;
  canonical: string;
  pram_1: any;
  pram_2: any;
}
export interface Name3 {
  id: number;
  code: string;
  sCode: string;
  name: string;
}
export interface Name4 {
  code: string;
  sysCode: number;
  desc: string;
}
export interface MyPaymentSettings {
  minCreditPayments: number;
  maxCreditPayments: number;
  maxRegularPayments: number;
  listOfRegularPayments: any[];
}
export interface ManageCmsProducts {
  listOfCmsProducts: ListOfCmsProduct[];
}
export interface ListOfCmsProduct {
  systemProducts: string;
  systemSubProducts: string;
  activeBook: boolean;
  activeDisplay: boolean;
  autoExportBackOffice: boolean;
  autoExportReceipt: boolean;
  autoIssueVoucher: boolean;
  autoIssueeTicket: boolean;
  notes: any;
  publicNotes: any;
  showSiteInsurance: boolean;
  showInsuranceExtensions: boolean;
  showPassportFields: boolean;
  displayBaggageAllowance: boolean;
  displayOnlyWithOutBaggageAllowance: boolean;
  showEmailAndPhoneFirstPaxOnly: boolean;
  listOfProductRules: any[];
  currency: string;
  shortReservationProcess: boolean;
  currencyOverRule: boolean;
  showManagePayments: boolean;
}
export interface ListOfCmsCheckOut {
  descLang: any[];
  checkOutType: string;
  id: number;
  parentId: number;
  uKey: string;
  parentKey: any;
  extKey: any;
  webKey: any;
  active: boolean;
  companyId: number;
  departmentId: number;
  branchId: number;
  userC: number;
  userU: number;
  userX: number;
  userO: number;
  dateC: string;
  dateU: string;
  dateX: string;
  delRow: number;
}
export interface SiteInsurance {
  listOfInsuranceExtension: any[];
  listofInsurancePolicy: any[];
}
export interface PageHeader {
  headerPage: HeaderPage;
  siteMenu: SiteMenu;
  siteSubMenu: SiteSubMenu;
}
export interface HeaderPage {
  active: boolean;
  hiddenPage: number;
  hiddenFromALL: number;
  title: Title;
  category: string;
  systemBasic: string;
  systemProducts: string;
  systemPageTemplate: string;
  listOfAtrributes: ListOfAtrribute[];
  strListOfAtrributes: string;
  listOfParamsAttr: any[];
  strListOfParamsAttr: string;
  systemProductsDetails: string;
  params: Params;
  listOfGalleryId: any[];
  strListOfGalleryId: string;
  externalDesc: string;
  languages: Language[];
  strLanguages: string;
  country: Country;
  city: City;
  geoCode: GeoCode;
  cmsScripts: CmsScripts;
  id: number;
  parentId: number;
  uKey: string;
  parentKey: string;
  extKey: string;
  webKey: string;
  companyId: number;
  departmentId: number;
  branchId: number;
  userC: number;
  userU: number;
  userX: number;
  dateC: string;
  dateU: string;
  dateX: string;
  orderDisplay: number;
  delRow: number;
}
export interface SiteMenu {
  mainPages: MainPage[];
}
export interface MainPage {
  orderDisplay: number;
  title: any;
  titleLang: TitleLang;
  defaultPageName: string;
  url: string;
  routeName: string;
  subPages: any[];
  isLargeMenu: boolean;
  category: string;
  systemProducts: string;
  country: Country;
}
export interface TitleLang {
  he: string;
  en: string;
  ru: string;
  it: string;
  jp: string;
  fr: string;
  gr: string;
  ch: string;
  ar: string;
  de: string;
  es: string;
  sr: string;
  ro: string;
}
export interface SiteSubMenu {
  mainPages: any[];
}
export interface PageFooter {
  footerPage: FooterPage;
  cmsPages: CmsPage[];
  cmsStandarPages: any[];
}
export interface FooterPage {
  active: boolean;
  hiddenPage: number;
  hiddenFromALL: number;
  title: Title;
  category: string;
  systemBasic: string;
  systemProducts: string;
  systemPageTemplate: string;
  listOfAtrributes: ListOfAtrribute[];
  strListOfAtrributes: string;
  listOfParamsAttr: any[];
  strListOfParamsAttr: string;
  systemProductsDetails: string;
  params: Params;
  listOfGalleryId: any[];
  strListOfGalleryId: string;
  externalDesc: string;
  languages: Language[];
  strLanguages: string;
  country: Country;
  city: City;
  geoCode: GeoCode;
  cmsScripts: CmsScripts;
  id: number;
  parentId: number;
  uKey: string;
  parentKey: string;
  extKey: string;
  webKey: string;
  companyId: number;
  departmentId: number;
  branchId: number;
  userC: number;
  userU: number;
  userX: number;
  dateC: string;
  dateU: string;
  dateX: string;
  orderDisplay: number;
  delRow: number;
}
export interface CmsPage {
  title: string;
}
export interface PageItem {
  searchBox?: SearchBox;
  pageContent?: PageContent;
  topDestinations: TopDestination;
  pageBanners: PageBanner[];
  pageTabs: PageBanner[];
  sales?: Sales;
  pageGuides: any;
  offlineSales?: OfflineSales;
  eventSales?: EventSales;
  slider?: Slider;
  orderDisplay: number;
  attributeId: number;
  attrubuteLayout: string;
  cmsAttribute: string;
  cmsAttributesDisaplyName: string;
  hasErrors: boolean;
  errorMessage: any;
}
export interface PageBanner {
  orderDisplayTab: number;
  tabCategory: string;
  active: boolean;
  hiddenPage: number;
  hiddenFromALL: number;
  title: Title;
  category: string;
  systemBasic: string;
  systemProducts: string;
  systemPageTemplate: string;
  listOfAtrributes: any[];
  strListOfAtrributes: string;
  listOfParamsAttr: any[];
  strListOfParamsAttr: string;
  systemProductsDetails: string;
  params: Params;
  listOfGalleryId: ListOfGalleryId[];
  strListOfGalleryId: string;
  externalDesc: string;
  languages: Language[];
  strLanguages: string;
  country: Country;
  city: City;
  geoCode: GeoCode;
  cmsScripts: CmsScripts;
  id: number;
  parentId: number;
  uKey: string;
  parentKey: string;
  extKey: string;
  webKey: string;
  companyId: number;
  departmentId: number;
  branchId: number;
  userC: number;
  userU: number;
  userX: number;
  dateC: string;
  dateU: string;
  dateX: string;
  orderDisplay: number;
  delRow: number;
}
export interface Title {
  desc: string;
  stringCompress: any;
  sub: string;
  menu: string;
  url: string;
  tab: string;
  openBlankURL: boolean;
  body: string;
}
export interface SearchBox {
  matrixConfig: MatrixConfig;
  matrixСode: any;
}
export interface MatrixConfig {
  matrixConfig: string;
  flightConfig: string;
  hotelConfig: string;
  transferConfig: string;
  eventTicketConfig: string;
}
export interface PageContent {
  desc: any;
  stringCompress: any;
  sub: any;
  menu: any;
  url: any;
  tab: any;
  openBlankURL: boolean;
  body: any;
}
export interface OfflineSales {
  tabs: {
    pageTab: Tab;
    deals: OfflineSalesDeal[];
  }[];
}
export interface OfflineSalesDeal {
  avgRoomPrice: number;
  cityDescription: string;
  packageName: string;
  package: OfflineSalesPackage;
  room: {
    numPax: number;
    numAdt: number;
    numCnn: number;
  };
  airlineLogo: string;
  flightEndDate: string;
  flightPrice: string;
  flightStartDate: string;
  productType: string;
}
export interface OfflineSalesPackage {
  flightOutBound: FlightOutBound;
  atomOrder: number;
  star: number;
  params: any[];
  country: Country;
  city: City;
  numberOfDays: number;
  atomCodes: any[];
  groupLang: GroupLang[];
  itinCodes: any[];
  externalLink: any;
  external: External;
  geoCode: GeoCode;
  port: any;
  hoteltDesc: string;
  startDate: string;
  endDate: string;
  numberOfNights: number;
  price: any;
  oneItemPriceId: number;
  extKey: any;
  listOfInformationLangs: ListOfInformationLang[];
  listOfNotIncludeInfoLangs: ListOfNotIncludeInfoLang[];
  listOfIncludeInfoLangs: ListOfIncludeInfoLang[];
  listOfAttractionLangs: ListOfAttractionLang[];
  listOfCheckOutLangs: ListOfCheckOutLang[];
  listOfPackageCancellationInfoLangs: ListOfPackageCancellationInfoLang[];
  listOfTestimonialLangs: ListOfTestimonialLang[];
  id: number;
  uKey: string;
  productType: string;
  group: Group;
  listofStartDate: any[];
  currency: string;
  oneItemPrice: OneItemPrice;
  atomLanguages: AtomLanguage[];
  beanAddress: BeanAddress;
  shortDesc: any;
  descLang: any[];
  itemName: ItemName;
  name: Name;
  nameLang: any[];
  shortDescLangs: any[];
  seO_Lang: any[];
  descLangs: DescLang[];
  images: Images;
}
export interface FlightOutBound {
  airline: string;
}
export interface Country {
  sCode: string;
  code: string;
  name: string;
}
export interface City {
  sCode: string;
  code: string;
  name: string;
}
export interface GroupLang {
  param_desc: any;
  desc: any;
  language: Language;
  listOfDesc: any[];
}
export interface External {
  sCode: string;
  code: string;
  name: string;
}
export interface GeoCode {
  latitude: string;
  longitude: string;
  pip: string;
}
export interface ListOfInformationLang {
  param_desc: any;
  desc: any;
  language: Language;
  listOfDesc: ListOfDesc[];
}
export interface ListOfDesc {
  sCode: string;
  code: string;
  name: string;
}
export interface ListOfNotIncludeInfoLang {
  param_desc: any;
  desc: any;
  language: Language;
  listOfDesc: ListOfDesc[];
}
export interface ListOfIncludeInfoLang {
  param_desc: any;
  desc: any;
  language: Language;
  listOfDesc: ListOfDesc[];
}
export interface ListOfAttractionLang {
  param_desc: any;
  desc: any;
  language: Language;
  listOfDesc: any[];
}
export interface ListOfCheckOutLang {
  param_desc: any;
  desc: any;
  language: Language;
  listOfDesc: any[];
}
export interface ListOfPackageCancellationInfoLang {
  param_desc: any;
  desc: any;
  language: Language;
  listOfDesc: any[];
}
export interface ListOfTestimonialLang {
  param_desc: any;
  desc: any;
  language: Language;
  listOfDesc: any[];
}
export interface Group {
  sCode: string;
  code: string;
  name: string;
}
export interface OneItemPrice {
  commision: Commision;
  pckRooms: any[];
  uKey: string;
  pckTransfers: any[];
  pckOthers: any[];
  flightOneAdult: any;
  listOfpckRoomTypeList: ListOfpckRoomTypeList[];
}
export interface Commision {
  markup: number;
  commisionType: string;
  presentOrAmount: number;
}
export interface ListOfpckRoomTypeList {
  pckRooms: PckRoom[];
  roomTypeListName: RoomTypeListName;
}
export interface PckRoom {
  board: Board;
  desc: any;
  class: Class;
  images: any;
  descLang: any[];
  nameLang: any[];
  uKey: string;
  roomCode: string;
  room: Room;
  name: Name;
  groupCode: any;
}
export interface Board {
  sCode: string;
  code: string;
  name: string;
}
export interface Class {
  sCode: string;
  code: string;
  name: string;
}
export interface Room {
  currency: string;
  bruto: number;
  nett: number;
  desc: string;
}
export interface Name {
  sCode: string;
  code: string;
  name: string;
}
export interface RoomTypeListName {
  sCode: string;
  code: string;
  name: string;
}
export interface AtomLanguage {
  sCode: string;
  code: string;
  name: string;
}
export interface BeanAddress {
  address: any;
  address_2: any;
  city: any;
  zip: any;
  state: State;
  country: Country;
  phoneNumber: any;
  fax: any;
  mobile: any;
  email: any;
  other: any;
}
export interface State {
  id: number;
  code: string;
  sCode: string;
  name: string;
}
export interface ItemName {
  sCode: string;
  code: string;
  name: string;
}
export interface Seo {
  keywords: any;
  description: string;
  title: string;
  canonical: string;
  pram_1: any;
  pram_2: any;
}
export interface DescLang {
  param_desc: any;
  desc: string;
  language: Language;
  listOfDesc: any[];
}
export interface Images {
  getImages: GetImage[];
}
export interface GetImage {
  thumbLink: string;
  imageLink: string;
  imgOrder: number;
  imageAlt: string;
  desc: string;
}
export interface EventSales {
  tabs: EventSaleTab[];
}
export interface Slider {
  active: boolean;
  hiddenPage: number;
  hiddenFromALL: number;
  title: Title;
  category: string;
  systemBasic: string;
  systemProducts: string;
  systemPageTemplate: string;
  listOfAtrributes: any[];
  strListOfAtrributes: string;
  listOfParamsAttr: any[];
  strListOfParamsAttr: string;
  systemProductsDetails: string;
  params: Params;
  listOfGalleryId: ListOfGalleryId[];
  strListOfGalleryId: string;
  externalDesc: string;
  languages: Language[];
  strLanguages: string;
  country: Country;
  city: City;
  geoCode: GeoCode;
  cmsScripts: CmsScripts;
  id: number;
  parentId: number;
  uKey: string;
  parentKey: string;
  extKey: string;
  webKey: string;
  companyId: number;
  departmentId: number;
  branchId: number;
  userC: number;
  userU: number;
  userX: number;
  dateC: string;
  dateU: string;
  dateX: string;
  orderDisplay: number;
  delRow: number;
}
export interface TopDestination {
  allDestinations: Page[];
  destionations: Destionation[];
}
export interface Title {
  desc: string;
  stringCompress: any;
  sub: string;
  menu: string;
  url: string;
  tab: string;
  openBlankURL: boolean;
  body: string;
}
export interface ListOfAtrribute {
  cmsAttributes: string;
  attribute: Attribute;
  orderDisplay: number;
  display: boolean;
  active: boolean;
  hideOnDesktop: boolean;
  hideOnMobile: boolean;
  myProperty: string;
  id: number;
}
export interface Attribute {
  id: number;
  code: string;
  codeR2: any;
  desc: string;
}
export interface Params {
  param_1: string;
  param_2: string;
  param_3: string;
  param_4: string;
  param_5: string;
}
export interface ListOfGalleryId {
  orderId: number;
  main: boolean;
  footer: boolean;
  param1: boolean;
  param2: boolean;
  mobileHidden: boolean;
  listOfLangs: ListOfLang[];
  id: number;
  code: string;
  alt: string;
  desc: string;
}
export interface ListOfDesc {
  id: number;
  code: string;
  sCode: string;
  name: string;
}
export interface Seo {
  keywords: any;
  description: string;
  title: string;
  canonical: string;
  pram_1: any;
  pram_2: any;
}
export interface Name {
  id: number;
  code: string;
  sCode: string;
  name: string;
}
export interface Country {
  id: number;
  code: string;
  sCode: string;
  name: string;
}
export interface City {
  id: number;
  code: string;
  sCode: string;
  name: string;
}
export interface GeoCode {
  latitude: string;
  longitude: string;
  pip: string;
}
export interface CmsScripts {
  desc: any;
  stringCompress: string;
  sub: any;
  menu: any;
  url: any;
  tab: any;
  openBlankURL: boolean;
  body: any;
}
export interface Destionation {
  city: City;
  page: Page;
  parents?: Page[];
}
export interface EventSaleTab {
  pageTab: PageTab;
  events: Event[];
}
export interface PageTab {
  orderDisplayTab: number;
  tabCategory: string;
  title: Title;
  maxElements: number;
  elementsInRow: number;
  openBlankURL: boolean;
  listOfAttributes: any[];
  listOfGalleryId: any[];
  tags: any[];
  uKey: string;
  parentKey: any;
  active: boolean;
  parentId: number;
  id: number;
  name: Name;
}
export interface Name {
  id: number;
  code: string;
  sCode: string;
  name: string;
}
export interface Event {
  startDates: StartDates[];
  paxes: any[];
  owner: Owner;
  siteInsurance: SiteInsurance;
  totalInsurance: number;
  totalServices: number;
  totalPrice: number;
  currency: any;
  orderId: number;
  orderSegmentId: number;
  transactionId: any;
  multiOrderId: number;
  getFromOwner: boolean;
  desc: string;
}
export interface Owner {
  firstName: any;
  lastName: any;
  email: any;
  phone: any;
  message: any;
}
export interface StartDates {
  id: number;
  startDate: string;
  endDate: string;
  images: any;
  title: Title;
  includeInfo: IncludeInfo;
  notIncludeInfo: NotIncludeInfo;
  information: Information;
  flights: any[];
  transfers: any[];
  hotels: any[];
  cruise: any;
  sportLtEevent: SportLtEevent;
  startPrice: number;
  currency: string;
}
export interface IncludeInfo {
  param_desc: any;
  desc: string;
  language: Language2;
  listOfDesc: any[];
}
export interface Language2 {
  sCode: string;
  code: string;
  name: string;
}
export interface NotIncludeInfo {
  param_desc: any;
  desc: string;
  language: Language3;
  listOfDesc: any[];
}
export interface Information {
  param_desc: any;
  desc: string;
  language: Language4;
  listOfDesc: any[];
}
export interface Language4 {
  sCode: string;
  code: string;
  name: string;
}
export interface SportLtEevent {
  finalDate: boolean;
  ticketDesc: string;
  currency: string;
  nettPrice: number;
  myPrice: MyPrice;
  pictureMap: string;
  qnt: number;
  shipping: string;
  purchasePage: string;
  showId: number;
  showName: string;
  itemNumber: number;
  categoryDesc: string;
  categoryType: string;
  vanueDesc: string;
  eventDate: string;
  cityName: string;
  countryName: string;
  countryCode: string;
  countrySysCode: string;
  bSupplier: BSupplier;
}
export interface MyPrice {
  gross: Gross;
  tax: Tax;
}
export interface Gross {
  fBase: number;
  currency: string;
  baseCurrencyCode: number;
  eur: number;
  usd: number;
  gbp: number;
  loc: number;
  netValue: number;
  llv: string;
  mv: string;
  value: number;
}
export interface Tax {
  fBase: number;
  currency: string;
  baseCurrencyCode: number;
  eur: number;
  usd: number;
  gbp: number;
  loc: number;
  netValue: number;
  llv: string;
  mv: string;
  value: number;
}
export interface BSupplier {
  id: number;
  code: string;
  sCode: string;
  name: string;
}
export interface InitSiteData {
  companyId: number;
  logoUrl: string;
  recapchaKey: string;
  styles: {
    [key: string]: string;
  };
  other: {
    siteTitle: string;
    freeCxl: string;
    hiddenCouponAmount: string;
    [key: string]: string;
  };
  apiKey: string;
}

export class ContactUsModel {
  firstName: string;
  phone: string;
  email: string;
  paxes: string;
  recaptchaToken?: string;
  lastName?: string;
  subject?: string;
  message?: string;
  confirmPromotions?: boolean;
  where?: string;
  when?: string;
  pageType?: string;
  partialName?: string;

  constructor() {
    this.firstName = '';
    this.phone = '';
    this.email = '';
    this.paxes = '1';
    this.lastName = '1';
    this.subject = '1';
    this.message = '';
    this.partialName = '1';
    this.when = '1';
    this.where = '1';
  }
}
